import { useTranslation } from '../../lib/i18n'

export default function WeaveAcceptedNotification({ notification }) {
  const { t } = useTranslation()
  return (
    <>
      <p className="w-full max-w-200 md:max-w-300 truncate overflow-hidden">
        <span className="text-off-black font-bold">
          {notification.notifiable?.recipient?.name}
        </span>{' '}
        {t('common.acceptedYourWeaveRequest')}
      </p>
    </>
  )
}
